import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import {
  getAdminProductTypes,
  addAdminProductType,
  updateAdminProductType,
  deleteAdminProductType
} from '../api/adminApi';

export const AdminProductTypes = () => {
  const { token } = useAdminAuth();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [nameInput, setNameInput] = useState('');

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const loadTypes = async () => {
    setLoading(true);
    const result = await getAdminProductTypes(token);
    setLoading(false);
    if (result.success) {
      setTypes(result.data.productTypes);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  useEffect(() => {
    loadTypes();
    // eslint-disable-next-line
  }, []);

  const openAddModal = () => {
    setEditingId(null);
    setNameInput('');
    setShowModal(true);
  };

  const openEditModal = (type) => {
    setEditingId(type.id);
    setNameInput(type.name);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!nameInput.trim()) return;

    const result = editingId
      ? await updateAdminProductType(token, editingId, nameInput)
      : await addAdminProductType(token, nameInput);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      setShowModal(false);
      loadTypes();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminProductType(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadTypes();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 className="w3-text-white">مدیریت نوع محصولات</h2>
        <button
          onClick={openAddModal}
          className="w3-button w3-round-xxlarge"
          style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}
        >
          <i className="material-icons w3-margin-left">add</i>
          افزودن نوع محصول
        </button>
      </div>

      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 10 }}>
        {loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : types.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>هیچ نوع محصولی ثبت نشده است.</p>
        ) : (
          <table className="w3-table w3-text-white" style={{ width: '100%' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #37474F' }}>
                <th style={{ textAlign: 'right', padding: 10 }}>#</th>
                <th style={{ textAlign: 'right', padding: 10 }}>نام</th>
                <th style={{ textAlign: 'left', padding: 10 }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {types.map((type) => (
                <tr key={type.id} style={{ borderBottom: '1px solid #263238' }}>
                  <td style={{ padding: 10 }}>{type.id}</td>
                  <td style={{ padding: 10 }}>{type.name}</td>
                  <td style={{ padding: 10, textAlign: 'left' }}>
                    <button onClick={() => openEditModal(type)} className="w3-button" style={{ color: '#4FC3F7' }}>
                      <i className="material-icons">edit</i>
                    </button>
                    <button onClick={() => setDeleteTarget(type)} className="w3-button" style={{ color: '#ff0000' }}>
                      <i className="material-icons">delete</i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* مودال افزودن/ویرایش */}
      {showModal && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 360, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ borderBottom: '1px solid #37474F' }}>
              <span onClick={() => setShowModal(false)} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{editingId ? 'ویرایش نوع محصول' : 'افزودن نوع محصول'}</h4>
            </div>
            <div className="w3-container w3-padding">
              <label className="w3-text-white">نام</label>
              <input
                type="text"
                value={nameInput}
                onChange={(e) => setNameInput(e.target.value)}
                className="w3-input"
                style={{ border: '1px solid white', backgroundColor: 'transparent', color: 'white', borderRadius: 8, height: 40 }}
              />
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={handleSave}
                className="w3-button w3-block"
                style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* مودال تایید حذف */}
      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">
                آیا از حذف «{deleteTarget.name}» مطمئن هستید؟ تمام برندها و فایل‌های مرتبط با این نوع محصول نیز حذف خواهند شد.
              </p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button onClick={() => setDeleteTarget(null)} className="w3-button" style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}>
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* پیام موفقیت/خطا */}
      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022', borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}` }}>
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-block" style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}>
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};